import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import ProjectDetails from '../../components/Project/ProjectDetails';


const ProjectShow = ({project, files, notes, uploadConfig, routeToIndex}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={project.name}
            items={[
                {
                    icon: 'arrow_back_ios',
                    text: i18n.get('default.nav.back'),
                    href: routeToIndex,
                    color: 'secondary',
                    size: 'small',
                },
                {
                    icon: 'history',
                    text: i18n.get('project.history.button'),
                    href: `/project/${project.id}/history`,
                    size: 'small',
                },
                {
                    icon: 'edit',
                    text: i18n.get('project.edit'),
                    href: `/project/${project.id}/edit`,
                    size: 'small',
                }
            ]}
        />

        <ProjectDetails project={project} files={files} notes={notes} uploadConfig={uploadConfig} />

    </Layout>
);

export default ProjectShow;
